import { render } from "./PosterSetting.vue?vue&type=template&id=5f871210&scoped=true"
import script from "./PosterSetting.vue?vue&type=script&lang=js"
export * from "./PosterSetting.vue?vue&type=script&lang=js"

import "./PosterSetting.vue?vue&type=style&index=0&id=5f871210&lang=less&scoped=true"

import exportComponent from "G:\\小程序\\OT ASAR\\vue后台\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f871210"]])

export default __exports__